/**
 * Created by yz on 2017/3/27.
 */
{
    angular.module('interfaceModule')
        .controller('OrderController',OrderController);
    OrderController.$inject = ['$scope',"$state",'$stateParams','request.order',
    'utils.currentUser','utils.uploadManager','utils.common','utils.constant'];
    function OrderController($scope,$state,$stateParams,orderRequest,
        currentUser,uploadManager,common,constant) {
        let vm=this;
        let collect={
            'activate':activate,
            'getOrderList':getOrderList,
            'orderList':[],
            'gotoOrderDetail':gotoOrderDetail,
            'tabOptions':[],
            'selectedTabIndex':0,
            'selectTab':selectTab,
            'gotoPay':gotoPay,
            'uploader':null,
            'gotoPrintAgain':gotoPrintAgain,
            'userInfo':null,
            'parterUser':true
        };
        vm.collect=collect;
        activate();

        function activate(){
            initTabOptions();

            if(currentUser.info){
                getOrderList(collect.tabOptions[collect.selectedTabIndex].status);
                //权限，测试通过后可删
                collect.userInfo = currentUser.info;
                /*if(collect.userInfo.groupname === "加盟商用户" || collect.userInfo.groupname ==="管理员" ){
                    collect.parterUser = true;
                }*/
            }else{
                let destructor=$scope.$on('user.logged',function(event,data){
                    collect.userInfo = data;
                    collect.userId = data.userId;
                    /*if(collect.userInfo.groupname === "加盟商用户" || collect.userInfo.groupname === "管理员"){
                        collect.parterUser = true;
                    }*/
                    getOrderList(collect.tabOptions[collect.selectedTabIndex].status);
                    destructor();
                });
            }
            
            uploadManager.init();
            collect.uploader=uploadManager.uploader;
            let delegate={};
            delegate.onWhenAddingFileFailed = function(item , filter, options) {
                // console.log('文件上传失败，请确认所传文件是否符合要求');
                common.prompt('文件上传失败，请确认所传文件是否符合要求');
            };
            delegate.onAfterAddingFile = function(fileItem) {
                // console.log(fileItem);
                $state.go('main.uploading');
            };
            uploadManager.callbackDelegateList.push(delegate);

            $scope.$on("$destroy", function(e) {
                // console.log("$destroy",$scope==e.targetScope);
                // if($scope==e.targetScope){
                    uploadManager.callbackDelegateList
                        .splice(uploadManager.callbackDelegateList.indexOf(delegate),1);
                    delegate=null;
                // }
                
            })
        }

        function initTabOptions(){
            collect.tabOptions=[
                            {"name":'待打印',"status":5},
                            {"name":'待支付',"status":1},
                            {"name":'已打印',"status":2},
                            {"name":'退款',"status":6},
                            {"name":'已完成',"status":3},
                            {"name":'所有订单',"status":0}
                            ];

        }

        function selectTab(index){
            collect.selectedTabIndex=index;
            getOrderList(collect.tabOptions[index].status);
        }

        function setCover(orderData){

            let path=constant.config.sitePath+constant.config.previewPath+"/";

            if (orderData.fileName.toLowerCase().endsWith(".doc") || orderData.fileName.toLowerCase().endsWith(".docx"))
            {
                orderData.coverPath=path+"file_type_word.png";
            }
            else if (orderData.fileName.toLowerCase().endsWith(".ppt") || orderData.fileName.toLowerCase().endsWith(".pptx"))
            {
                orderData.coverPath=path+"file_type_ppt.png";
            }
            else if (orderData.fileName.toLowerCase().endsWith(".pdf"))
            {
                orderData.coverPath=path+"file_type_pdf.png";
            }
            else {
                orderData.coverPath=path+"file_type_image.png";
            }
        }

        //1:待支付
        // 5:待打印
        // 2:已打印
        // 3:已完成
        // 4:已取消
        function getOrderList(status){
            common.loading.show();
            collect.orderList=[];
            orderRequest.getOrderList(status)
            .then(function(data){//console.log(data);
                // console.log(data);
                common.loading.hide();
                collect.orderList=data;
                for(let i=0;i<collect.orderList.length;i++){
                    setCover(collect.orderList[i]);
                }
                // console.log(collect.orderList);
            },function(){
                common.loading.hide();
            });
        }

        function gotoOrderDetail(order){
            $state.go('main.orderDetail',{'orderId':order.orderId});
        }

        function gotoPay(order){
            $state.go('main.pay',{'orderId':order.orderId});
        }
        function gotoPrintAgain(order) {
            $state.go('main.printSettings',{'orderId':order.orderId,'canprintagain':order.canprintagain});
        }

    }
    
}